export default function money(value) {
    return '<span class="__currency">£</span>' + value;
}